import Nullstack from 'nullstack';
export default function IconPictureInPictureOn({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-picture-in-picture-on",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
  }), "   ", Nullstack.element("rect", {
    x: "14",
    y: "14",
    width: "7",
    height: "5",
    rx: "1"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "9",
    x2: "11",
    y2: "13"
  }), "   ", Nullstack.element("path", {
    d: "M8 13h3v-3"
  }), " ");
}